import useHasPermission from 'app/hooks/useHasPermission'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    getUrlsFromTableConfig,
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'

import useTabsByPermission from 'app/hooks/useTabsByPermission'

import useContainerManagementRoutes from 'app/SkyNetRoutes/hooks/useContainerManagementRoutes'
import useLabel from 'app/hooks/useLabel'

import CreateContainer from './components/CreateContainer'
import PrintLabel from './components/PrintLabel'
import Overview from './components/Overview'
import ChangeData from './components/ChangeData'
import ChangeStatus from './components/ChangeStatus'
import LoggerExchange from './components/LoggerExchange'
import SensorData from './components/SensorData'
import Damages from './components/Damages'
import tableConfig from './Container.config'
import Geolocation from './components/Geolocation'
import AutomatedSensorChecks from './components/AutomatedSensorChecks'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const Containers = () => {
    const l = useLabel()
    const {
        Containers: ContainersRoutes,
    } = useContainerManagementRoutes()
    const containerCreate = useHasPermission(['container_create'])
    const containerUpdate = useHasPermission(['container_update'])

    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                label: l('OVERVIEW'),
                url: ContainersRoutes.Overview.route,
                Component: Overview,
            },
            permission: true,
        },
        {
            tab: {
                label: l('DATA_UPDATE'),
                url: ContainersRoutes.Update.route,
                Component: ChangeData,
            },
            permission: containerUpdate,
        },
        {
            tab: {
                label: l('STATUS_UPDATE'),
                url: ContainersRoutes.ChangeStatus.route,
                Component: ChangeStatus,
            },
            permission: containerUpdate,
        },
        {
            tab: {
                label: l('LOGGERS'),
                url: ContainersRoutes.Loggers.route,
                Component: LoggerExchange,
            },
            permission: containerUpdate,
        },
        {
            tab: {
                label: l('SENSOR_DATA'),
                url: ContainersRoutes.SensorData.route,
                Component: SensorData,
            },
            permission: true,
        },
        {
            tab: {
                label: l('AUTOMATED_SENSOR_CHECKS'),
                url: ContainersRoutes.AutomatedSensorChecks.route,
                Component: AutomatedSensorChecks,
            },
            permission: true,
        },
        {
            tab: {
                label: l('DAMAGES'),
                url: ContainersRoutes.Damages.route,
                Component: Damages,
            },
            permission: true,
        },
        {
            tab: {
                label: l('GEOLOCATION'),
                url: ContainersRoutes.Geolocation.route,
                Component: Geolocation,
            },
            permission: true,
        },
    ])

    return (
        <SkyNetDomain
            actionComponents={{
                Create: containerCreate ? CreateContainer : undefined,
                Print: PrintLabel,
            }}
            name="ContainerView"
            uniqField="serialNumber"
            defaultTab={ContainersRoutes.Overview.route}
            sidebarTabs={tabs}
            subdomainUrls={getUrlsFromTableConfig(tableConfig)}
        >
            <SkyNetTable
                moduleName="Container"
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>

    )
}

export default Containers
